import { Fab, Dialog, DialogTitle, DialogContent } from "@mui/material";
import { useState } from "react";
import Iconify from '../../../../reusable-components/iconify';
import DialogButtons from './DialogButtons';
import CloseIconButton from '../../../../reusable-components/basic-buttons/CloseIconButton';

export default function MobileNewOrderAndTicket() {
  const [openDialog, setOpenDialog] = useState(false);

  const handleClickOpen = () => {
    setOpenDialog(true);
  };

  const handleClose = () => {
    setOpenDialog(false);
  };
  return <>
    <Fab
      color="white"
      size="small"
      onClick={handleClickOpen}
      sx={{
        boxShadow: 'none',
        color: (theme) => theme.palette.secondary.main,
        border: (theme) => `1px solid ${theme.palette.secondary.main}`,
        width: 28,        
        height: 28,       
        minWidth: 28,     
        minHeight: 28,
        zIndex: 3,
      }}
    >
      <Iconify height={20} width={20}sx={{color: (theme) => theme.palette.secondary.main}} icon="mdi:plus"/>
    </Fab>
    <Dialog
      open={openDialog}
      onClose={(event, reason) => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
        handleClose();
      }}
      fullWidth
    >
      <DialogTitle sx={{ textAlign: 'right' }}>
        <CloseIconButton onClick={handleClose}/>
      </DialogTitle>
      <DialogContent>
        <DialogButtons openDialog={openDialog} setOpenDialog={setOpenDialog} />
      </DialogContent>
    </Dialog>
  </>;
}